import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import { EmendaEstadualService } from "../../services/EmendaEstadualService";

export default {
    name: "GerenciarEmendasEstaduais",
    components: {
        Breadcrumb,
        StandardPagination
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciar EP. Emenda Estadual',
                disabled: true
            }
        ],
        baseHeaders: [
            { text: '', align: 'center', value: 'data-table-select', sortable: false, width: '50px' },
            { text: 'Ano', align: 'center', value: 'ano', width: '100px' },
            { text: 'Parlamentar', align: 'center', value: 'parlamentar', width: '150px' },
            { text: 'Gerência', align: 'center', value: 'gerencia', width: '120px' },
            { text: 'Indicação', align: 'center', value: 'indicacao', width: '300px' },
            { text: 'Emenda', align: 'center', value: 'emenda', width: '120px' },
            { text: 'Unidade(s)', align: 'center', value: 'unidades', width: '200px' },
            { text: 'Cidade(s)', align: 'center', value: 'cidades', width: '200px' },
            { text: 'Valor Total Previsto', align: 'center', value: 'valor_total_previsto', width: '170px' },
        ],
        filters: {
            anoFilter: null,
            parlamentarFilter: null,
            gerenciaFilter: null,
            indicacaoFilter: '',
            emendaFilter: '',
            unidadesFilter: [],
            cidadesFilter: [],
            dataPublicacaoFilter: null,
            valorTotalDeFilter: '',
            valorTotalAteFilter: '',
        },
        items: [],
        itemSelected: [],
        showFilters: true,
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        loading: false,
        filterTimeout: null,
        menuDataPublicacao: false,
        // Opções para os filtros
        anosOptions: [],
        parlamentaresOptions: [],
        gerenciasOptions: [],
        unidadesOptions: [],
        cidadesOptions: [],
        // Search inputs para autocomplete
        parlamentarSearch: '',
        unidadesSearch: '',
        cidadesSearch: '',
        // Timeouts para autocomplete
        parlamentarSearchTimeout: null,
        unidadesSearchTimeout: null,
        cidadesSearchTimeout: null,
        windowWidth: window.innerWidth,
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        },
        computedHeaders() {
            const isSmallScreen = this.windowWidth < 1200;
            return this.baseHeaders.map(header => {
                if (header.value === 'valor_total_previsto') {
                    return {
                        ...header,
                        text: isSmallScreen ? 'Valor Total' : 'Valor Total Previsto'
                    };
                }
                return header;
            });
        }
    },
    created() {
        this.listarEmendasEstaduaisPaginado();
        this.carregarOpcoesFiltros();
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarEmendasEstaduaisPaginado();
        }
    },
    methods: {
        async listarEmendasEstaduaisPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();

                const response = await EmendaEstadualService.index(filter);

                if (typeof response !== 'string' && response && response.data) {
                    this.items = response.data.data || [];
                    this.totalItems = response.data.total || 0;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter as emendas estaduais.');
                    this.items = [];
                    this.totalItems = 0;
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar as emendas estaduais:', error);
                this.items = [];
                this.totalItems = 0;
            } finally {
                this.loading = false;
            }
        },
        async carregarOpcoesFiltros() {
            try {
                // Carregar anos
                const anosResponse = await EmendaEstadualService.getAnosOptions();
                if (anosResponse && anosResponse.data) {
                    this.anosOptions = anosResponse.data.map(ano => ({
                        text: String(ano),
                        value: ano
                    }));
                }

                // Carregar gerências
                const gerenciasResponse = await EmendaEstadualService.getGerenciasOptions();
                if (gerenciasResponse && gerenciasResponse.data) {
                    this.gerenciasOptions = gerenciasResponse.data.map(gerencia => ({
                        text: gerencia,
                        value: gerencia
                    }));
                }

                // Carregar opções iniciais de parlamentares
                await this.buscarParlamentaresOptions('');

                // Carregar opções iniciais de unidades
                await this.buscarUnidadesOptions('');

                // Carregar opções iniciais de cidades
                await this.buscarCidadesOptions('');
            } catch (error) {
                console.error('Ocorreu um erro ao carregar as opções dos filtros:', error);
            }
        },
        async buscarParlamentaresOptions(search = '') {
            try {
                const response = await EmendaEstadualService.autocomplete('parlamentar', search);
                if (response && response.data) {
                    this.parlamentaresOptions = response.data.map(parlamentar => ({
                        text: parlamentar,
                        value: parlamentar
                    }));
                }
            } catch (error) {
                console.error('Erro ao buscar parlamentares:', error);
            }
        },
        async buscarUnidadesOptions(search = '') {
            try {
                const response = await EmendaEstadualService.getUnidadesOptions(search);
                if (response && response.data) {
                    this.unidadesOptions = response.data.map(unidade => ({
                        text: unidade,
                        value: unidade
                    }));
                }
            } catch (error) {
                console.error('Erro ao buscar unidades:', error);
            }
        },
        async buscarCidadesOptions(search = '') {
            try {
                const response = await EmendaEstadualService.getCidadesOptions(search);
                if (response && response.data) {
                    this.cidadesOptions = response.data.map(cidade => ({
                        text: cidade,
                        value: cidade
                    }));
                }
            } catch (error) {
                console.error('Erro ao buscar cidades:', error);
            }
        },
        handleParlamentarSearch() {
            if (this.parlamentarSearchTimeout) {
                clearTimeout(this.parlamentarSearchTimeout);
            }
            this.parlamentarSearchTimeout = setTimeout(() => {
                this.buscarParlamentaresOptions(this.parlamentarSearch || '');
            }, 300);
        },
        handleUnidadesSearch() {
            if (this.unidadesSearchTimeout) {
                clearTimeout(this.unidadesSearchTimeout);
            }
            this.unidadesSearchTimeout = setTimeout(() => {
                this.buscarUnidadesOptions(this.unidadesSearch || '');
            }, 300);
        },
        handleCidadesSearch() {
            if (this.cidadesSearchTimeout) {
                clearTimeout(this.cidadesSearchTimeout);
            }
            this.cidadesSearchTimeout = setTimeout(() => {
                this.buscarCidadesOptions(this.cidadesSearch || '');
            }, 300);
        },
        prepareFormFilter() {
            const filter = new FormData();
            
            if (this.filters.anoFilter !== null && this.filters.anoFilter !== '') {
                filter.append("ano", this.filters.anoFilter);
            }
            
            if (this.filters.parlamentarFilter) {
                filter.append("parlamentar", this.filters.parlamentarFilter);
            }
            
            if (this.filters.gerenciaFilter) {
                filter.append("gerencia", this.filters.gerenciaFilter);
            }
            
            if (this.filters.indicacaoFilter) {
                filter.append("indicacao", this.filters.indicacaoFilter);
            }
            
            if (this.filters.emendaFilter) {
                filter.append("emenda", this.filters.emendaFilter);
            }
            
            if (this.filters.unidadesFilter && this.filters.unidadesFilter.length > 0) {
                this.filters.unidadesFilter.forEach(unidade => {
                    filter.append("unidades[]", unidade);
                });
            }
            
            if (this.filters.cidadesFilter && this.filters.cidadesFilter.length > 0) {
                this.filters.cidadesFilter.forEach(cidade => {
                    filter.append("cidades[]", cidade);
                });
            }
            
            if (this.filters.dataPublicacaoFilter) {
                filter.append("data_publicacao_ate", this.filters.dataPublicacaoFilter);
            }
            
            if (this.filters.valorTotalDeFilter) {
                const valor = this.parseValorMonetario(this.filters.valorTotalDeFilter);
                if (valor !== null) {
                    filter.append("valor_total_previsto_de", valor);
                }
            }
            
            if (this.filters.valorTotalAteFilter) {
                const valor = this.parseValorMonetario(this.filters.valorTotalAteFilter);
                if (valor !== null) {
                    filter.append("valor_total_previsto_ate", valor);
                }
            }
            
            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);
            
            return filter;
        },
        
        // Métodos para o componente StandardPagination
        handlePageChanged(newPage) {
            this.page = newPage;
        },
        
        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarEmendasEstaduaisPaginado();
        },
        
        truncateText(text, maxLength) {
            if (!text || text.length <= maxLength) {
                return text || '-';
            }
            return text.substring(0, maxLength) + '...';
        },

        formatCurrency(value) {
            if (!value && value !== 0) {
                return '-';
            }
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },

        formatUnidades(unidades) {
            if (!unidades) return '-';
            if (typeof unidades === 'string') {
                return unidades;
            }
            if (Array.isArray(unidades)) {
                return unidades.join(', ');
            }
            return String(unidades);
        },

        formatCidades(cidades) {
            if (!cidades) return '-';
            if (typeof cidades === 'string') {
                return cidades;
            }
            if (Array.isArray(cidades)) {
                return cidades.join(', ');
            }
            return String(cidades);
        },

        // Formatação monetária
        parseValorMonetario(valor) {
            if (!valor || valor === '') return null;
            const cleaned = String(valor).replace(/[^\d]/g, '');
            if (cleaned === '') return null;
            const parsed = parseFloat(cleaned);
            return isNaN(parsed) ? null : parsed;
        },

        handleValorInput(field, value) {
            const cleaned = String(value).replace(/[^\d]/g, '');
            this.filters[field] = cleaned;
        },

        formatValor(field) {
            if (!this.filters[field] || this.filters[field] === '') {
                this.filters[field] = '';
                return;
            }
            const valor = parseFloat(this.filters[field]);
            if (!isNaN(valor)) {
                this.filters[field] = String(valor);
            } else {
                this.filters[field] = '';
            }
        },

        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        
        clearFilters() {
            this.filters = {
                anoFilter: null,
                parlamentarFilter: null,
                gerenciaFilter: null,
                indicacaoFilter: '',
                emendaFilter: '',
                unidadesFilter: [],
                cidadesFilter: [],
                dataPublicacaoFilter: null,
                valorTotalDeFilter: '',
                valorTotalAteFilter: '',
            };
            this.parlamentarSearch = '';
            this.unidadesSearch = '';
            this.cidadesSearch = '';
            this.page = 1;
            this.listarEmendasEstaduaisPaginado();
        },
        
        handleFilterChange() {
            // Debounce para evitar muitas chamadas à API
            if (this.filterTimeout) {
                clearTimeout(this.filterTimeout);
            }
            
            this.filterTimeout = setTimeout(() => {
                this.page = 1;
                this.listarEmendasEstaduaisPaginado();
            }, 300);
        },
        
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },

        // Método para definir classes das linhas da tabela
        getRowClass() {
            return 'row-standard';
        },

        handleResize() {
            this.windowWidth = window.innerWidth;
        }
    }
};

